import { useContext } from 'react';
import { Table, Col, Image, NavLink } from 'react-bootstrap';
import { ContactContext } from '../context/ContactContext';
import '../assets/scss/components/contact-card.scss';
import location from '../assets/images/location.svg';
import mail from '../assets/images/min-email.svg';
import phone from '../assets/images/min-phone.svg';
import whatsapp from '../assets/images/whatsapp.svg';


function ContactCard({ type }) {
    const contact = useContext(ContactContext);
    const phoneNumbers = contact?.phone_number
        ? contact.phone_number.replaceAll(' ', '').split(',')
        : [];
    const email = contact?.email;

    return (
        <Col className="table-wrapper pt-5 pb-4 px-3 mx-lg-auto">
            <Table className="table-borderless">
                <tbody>
                    {/* Address */}
                    <tr className='address'>
                        {
                            type === "text"
                                ? <td><h6>Address:</h6></td>
                                : <td><Image src={ location } /></td>
                        }
                        <td><p>Lekki-Ajah, Lagos</p></td>
                    </tr>

                    {/* Email */}
                    <tr className='email'>
                        {
                            type === "text"
                                ? <td><h6>Email:</h6></td>
                                : <td><Image src={ mail } /></td>
                        }
                        {
                            email &&
                            <td className='text-decoration-underline'>
                                <NavLink href={`mailto:${email}`}>{ email }</NavLink>
                            </td>
                        }
                    </tr>

                    {/* Phone number */}
                    {
                        type === 'text' ?
                            <tr className='phone'>
                                <td><h6>Tel:</h6></td>
                                { phoneNumbers &&
                                    <td>
                                        { contact && contact?.phone_number.split(", ").map((phone, index) => (
                                            <NavLink href={`tel:${phoneNumbers[index]}`} key={ index }>{ phone }</NavLink>
                                        ))}
                                    </td>
                                }
                            </tr>
                        : <>
                            <tr className='phone'>
                                <td><Image src={ phone } /></td>
                                <td><NavLink href={`tel:+2347060624342`}>+234 706 062 4342</NavLink></td>
                            </tr>
                            <tr className='whatsapp'>
                                <td><Image src={ whatsapp } /></td>
                                { phoneNumbers &&
                                    <td>
                                        { contact && contact?.phone_number.split(", ").map((phone, index) => (
                                            <NavLink href={`tel:${phoneNumbers[index]}`} key={index}>{ phone }</NavLink>
                                        ))}
                                    </td>
                                }
                            </tr>
                        </>
                    }
                </tbody>
            </Table>
        </Col>
    )
}

export default ContactCard;
